import type { Move } from '../../../schemas/move';

/**
 * Archetipi del Paladino (manuale V1, rr. 4842-4850).
 *
 * 5 mosse di tipo `class_special`. Pattern razza-tematico standard.
 *
 * **Archetipo Elfo**: «aggiungi la Tradizione Sacra della Natura a quelle
 * che puoi scegliere con *Ordine Sacro*. Inoltre, quando prendi la mossa
 * *Crociato* o *Templare*, puoi scegliere anche tra le mosse del Druido.»
 * — il vincolo "Tradizione Natura solo se Elfo" è già modellato a livello
 * di `SpellAccess.requiresArchetype` (FI-2 risolto). Il riferimento alle
 * mosse multiclasse del Druido resta description-only (FI-17).
 *
 * **Archetipo Nano**: «i tuoi PF massimi sono 12+Costituzione» — modellato
 * via `Archetype.baseHpOverride: 12` (FI-1 risolto in questa PR), propagato
 * in `services/characterCreation.ts::deriveStartingDerivedStats`.
 */

const archetipoUmano: Move = {
  id: 'paladino.archetipo-umano',
  name: 'Archetipo: Umano',
  type: 'class_special',
  classId: 'paladino',
  trigger: 'Quando dai un ordine a qualcuno e questi lo esegue senza fiatare',
  description: 'Egli ottiene +1 al prossimo tiro.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoElfo: Move = {
  id: 'paladino.archetipo-elfo',
  name: 'Archetipo: Elfo',
  type: 'class_special',
  classId: 'paladino',
  trigger: "Alla creazione del personaggio (alla scelta dell'archetipo)",
  description:
    'Aggiungi la Tradizione Sacra della **Natura** a quelle che puoi scegliere con *Ordine Sacro*. Inoltre, quando prendi la mossa *Crociato* o *Templare*, puoi scegliere anche tra le mosse del Druido.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoNano: Move = {
  id: 'paladino.archetipo-nano',
  name: 'Archetipo: Nano',
  type: 'class_special',
  classId: 'paladino',
  trigger: 'Alla creazione del personaggio (statistiche)',
  description: 'I tuoi PF massimi sono **12+Costituzione** invece di 10+Costituzione.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoHalfling: Move = {
  id: 'paladino.archetipo-halfling',
  name: 'Archetipo: Halfling',
  type: 'class_special',
  classId: 'paladino',
  trigger: 'Quando *discerni la realtà* riguardo una creatura',
  description:
    "Aggiungi la domanda «*L'entità ultraterrena cui sono devoto cosa vorrebbe che facessi con questa creatura?*» a quelle che puoi fare, e prendi +1 al prossimo tiro se agisci in accordo alla risposta ricevuta.",
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoMezzorco: Move = {
  id: 'paladino.archetipo-mezzorco',
  name: "Archetipo: Mezz'orco",
  type: 'class_special',
  classId: 'paladino',
  trigger: 'Quando hai una Debilitazione',
  description:
    'Puoi scegliere di subire 2 danni (*ignora armatura*) per avere un +1 al prossimo tiro che richieda quella Caratteristica.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

export const paladinoArchetypeMoves: readonly Move[] = [
  archetipoUmano,
  archetipoElfo,
  archetipoNano,
  archetipoHalfling,
  archetipoMezzorco,
] as const;
